// components/common/RouteLoader.jsx
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import LoadingState from "../../core/common/LoadingState";
export default function RouteLoader({ children }) {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);

    const id = setTimeout(() => {
      setLoading(false);
      window.scrollTo(0, 0);
    }, 1000);

    return () => clearTimeout(id);
  }, [location.pathname]);

  return (
    <>
      {loading && <LoadingState type="fullscreen" />}
      {children}
    </>
  );
}

RouteLoader.propTypes = {
  children: PropTypes.node.isRequired,
};